import { render } from "./PresupuestosAxa.vue?vue&type=template&id=617b725c&scoped=true"
import script from "./PresupuestosAxa.vue?vue&type=script&lang=js"
export * from "./PresupuestosAxa.vue?vue&type=script&lang=js"

import "./PresupuestosAxa.vue?vue&type=style&index=0&id=617b725c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-617b725c"]])

export default __exports__